// Einstiege in die Vorschau (M20) aus Editoren und Listen. Bewusst ohne Engine-Import,
// damit die Engine nur mit der Vorschau-Seite geladen wird.
export type PreviewKind = 'playlist' | 'layout' | 'schedule' | 'screen';

/** Adresse der Vorschau, z. B. /preview/playlist/<id>?item=<eintrag>. */
export function previewPath(type: PreviewKind, id: string, params: Record<string, string> = {}): string {
  const q = new URLSearchParams(params).toString();
  return `/preview/${type}/${id}${q ? `?${q}` : ''}`;
}

/** Ziel von „Schliessen", wenn die Vorschau nicht in einem eigenen Tab läuft. */
export function backPath(type: PreviewKind, id: string): string {
  return { playlist: `/playlists/${id}`, layout: '/templates', schedule: `/schedules/${id}`, screen: `/screens/${id}` }[type];
}

/**
 * Vorschau in neuem Tab öffnen. `before` (z. B. Entwurf speichern) läuft, nachdem der Tab schon offen ist,
 * damit der Popup-Blocker nicht eingreift; schlägt es fehl, wird der Tab wieder geschlossen.
 */
export async function openPreview(type: PreviewKind, id: string, before?: () => Promise<unknown>, params: Record<string, string> = {}): Promise<void> {
  const url = previewPath(type, id, params);
  if (!before) {
    window.open(url, '_blank');
    return;
  }
  const w = window.open('', '_blank');
  try {
    await before();
  } catch (e) {
    w?.close();
    throw e;
  }
  if (w) w.location.href = url;
  else window.location.href = url;
}
